import { module } from "angular";
import errorHandling from "@gtmhub/error-handling/module";
import localization from "@gtmhub/localization/module";
import chartist from "@gtmhub/shared/libs/chartist/chartist.module";
import { loadModuleStyles } from "@gtmhub/shared/ng-extensions/util";
import usersCore from "@gtmhub/users/users-core.module";
import { GenericCardComponent } from "./components/generic-card/generic-card.component";
import { GenericListCardComponent } from "./components/generic-list-card/generic-list-card";
import { GroupDetailsCellComponent } from "./components/group-details-sidebar/group-details-cell/group-details-cell.component";
import { GroupDetailsSidebarComponent } from "./components/group-details-sidebar/group-details-sidebar.component";
import { GroupDetailsSidebarService } from "./components/group-details-sidebar/group-details-sidebar.service";
import { LatestSectionComponent } from "./components/latest-section/latest-section.component";
import { PersonalBestSectionComponent } from "./components/personal-best-section/personal-best-section.component";
import { ProcessSectionComponent } from "./components/process-section/process-section.component";
import { ProfileSessionFilterComponent } from "./components/profile-session-filter/profile-session-filter.component";
import { ProgressAndProcessSectionComponent } from "./components/progress-and-process-section/progress-and-process-section.component";
import { ProgressSectionComponent } from "./components/progress-section/progress-section.component";
import { TasksSectionComponent } from "./components/tasks-section/tasks-section.component";
import moduleStyles from "./profile.module.less";
import { ProfileService } from "./services/profileService";

const mod = module("profile", [errorHandling, usersCore, localization, chartist]);
mod.service("ProfileService", ProfileService);
mod.component("genericCard", GenericCardComponent);
mod.component("genericListCard", GenericListCardComponent);
mod.component("processSection", ProcessSectionComponent);
mod.component("tasksSection", TasksSectionComponent);
mod.component("latestSection", LatestSectionComponent);
mod.component("personalBestSection", PersonalBestSectionComponent);
mod.component("progressSection", ProgressSectionComponent);
mod.component("progressAndProcessSection", ProgressAndProcessSectionComponent);
mod.component("profileSessionFilter", ProfileSessionFilterComponent);
mod.component("groupDetailsSidebar", GroupDetailsSidebarComponent);
mod.component("groupDetailsCell", GroupDetailsCellComponent);
mod.service("GroupDetailsSidebarService", GroupDetailsSidebarService);

loadModuleStyles(mod, moduleStyles);

export default mod.name;
